// extracted by mini-css-extract-plugin
module.exports = {"previewer":"Previewer_previewer__1jGZA","active":"Previewer_active__3tXNR"};